import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";

export class memberContactUs {
	private contactForm: any = $('#member-contact-form');
	private memberBase: any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		$("#successMessage").hide();
		let inputElArr: any = $.makeArray(_self.contactForm.find('input[type="text"], textarea'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;

		let titleInput = $('#member--category');
		let getTitleOptions = $.Deferred();

		$.get('/content/dam/mas/json/enquiryCategory.json')
			.done((data: any) => {
				let listItems = "<option value=''> </option>";
				for (let i = 0; i < data.enquiryCategory.length; i++) {
					listItems += "<option value='" + data.enquiryCategory[i].label + "' data-category='" + data.enquiryCategory[i].value + "'>" + data.enquiryCategory[i].value + "</option>";
				}
				getTitleOptions.resolve(listItems);
			})
			.fail((error: any) => {
				getTitleOptions.reject(error);
			});
		$(titleInput).change(function (event: any) {
			let selectedValue = $(event.currentTarget).find(':selected').html();
			$('#member--selected-category').attr('selected-category', selectedValue);
		});
		$.when(getTitleOptions).done(function (titleOptions: any) {
			titleInput.html(titleOptions);
			let inputSelectArr: any = $.makeArray(_self.contactForm.find('select'));
			_self.memberBase.initSelectizeInputs(inputSelectArr);
		});
	}

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.contactForm,
			function (validation: any) {
				// all your custom validation here

			},
			function (validation: any, formData: any, htmlFormData: any) {
				// on success function
				let submitBtn = _self.contactForm.find('#contact-form--submit');
				let successMsg = _self.contactForm.parents().eq(1).find('#password-change-success');

				$("div#password-change-success").attr({ 'style': 'width: auto' });

				submitBtn.fadeOut();
				successMsg.fadeIn();

			}
		);
	}

	initContactForm(): any {
		$('#contact-form--submit').click(function () {
			adobeDataLayer.push('click', {
				'pageName': '',
				'pageType': 'Enrich Fly Contact Us',
				'clickName': 'click:btn-click:contact-us-submit',
				'componentType': 'btn',
				'componentName': '',
				'componentID': '',
				'attributes': []
			});
		});
		$('#member--upload').click(function (e: any) {
			adobeDataLayer.push('click', {
				'pageName': '',
				'pageType': 'Enrich Fly Contact Us',
				'clickName': 'click:btn-click:choose-file',
				'componentType': 'btn',
				'componentName': '',
				'componentID': '',
				'attributes': []
			});
		});
		$('#member--upload').change(function (e: any) {
			let acceptedFileFormat = ["jpg", "png", "pdf", "docx", "doc"];
			let fileObj = e.currentTarget.files[0];
			let name = fileObj.name;
			var period = name.lastIndexOf(".");
			let filesExtenstion = name.substr(period + 1, name.length);
			let sizeInMB = returnFileSize(fileObj.size);
			if (acceptedFileFormat.indexOf(filesExtenstion.toLowerCase()) === -1) {
				// disbaled the submit button
				$('#contact-form--submit').attr("disabled", true);
				$('.file-extenstion-error').removeClass('hideclass');
				$('.file-extenstion-error').addClass('showclass');
				$('.max-file-error').removeClass('showclass');
				$('.max-file-error').addClass('hideclass');
				e.currentTarget.files = null;
			} else if (parseInt(sizeInMB) > 5) {
				$('#contact-form--submit').attr("disabled", true);
				$('.max-file-error').removeClass('hideclass');
				$('.max-file-error').addClass('showclass');
				$('.file-extenstion-error').removeClass('showclass');
				$('.file-extenstion-error').addClass('hideclass');
			} else {
				// good with file validation
				$('#contact-form--submit').attr("disabled", false);
				$('.file-extenstion-error').removeClass('showclass');
				$('.file-extenstion-error').addClass('hideclass');
				$('.max-file-error').removeClass('showclass');
				$('.max-file-error').addClass('hideclass');
			}
		});
		function returnFileSize(number: any) {
			return (number / 1048576).toFixed(1);
		}
	}
	getCardStatusForPlatinum(): void {
		let authenticationUrl: string = '';
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			authenticationUrl = '/dummy-data/getMemberShipData.json';
		}
		else {
			authenticationUrl = '/bin/services/new/getMembershipLCPAPI';
		}
		var data = {
			'action': 'fetch'
		};
		$.ajax({
			type: 'POST',
			url: authenticationUrl,
			data: data,
			async: false,
			success: function (data: any) {
				if (typeof data === 'string') {
					data = JSON.parse(data);
				}
				if (data.cardType === "p" || data.cardType === "P") {
					$(".contact-section-platinum").removeClass("hide");
				} else {
					$(".contact-section-platinum").addClass("hide");
				}
			}
		});

	}
	makeAppointment(): void {
		$("#make-appointment--submit").click(function () {
			let authenticationUrl: string = '';
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				authenticationUrl = '/dummy-data/getMemberShipData.json';
			}
			else {
				authenticationUrl = '/bin/services/new/makeApptmentContactUS';
			}
			$.ajax({
				type: 'POST',//Change to POST if required
				url: authenticationUrl,
				//data: formData,
				success: function (data: any) {
					if (typeof data === 'string') {
						data = JSON.parse(data);
					}
					if (data.statusCode == 'OK') {
						let rediURL = data.message
						alert("rediURL"+rediURL);
						window.location.href = rediURL;
						//window.location.replace(rediURL);
					} else {
						alert("Please Try After Sometime");
					}
				}
			});
		});
	}
}


let scope: Element = document.querySelector('#member-contact-form');

if (scope) {
	try {
		let membercontactus = new memberContactUs();
		var adobeDataLayer = new adobeDataLayerWrapper();
		membercontactus.initTextInputs();
		membercontactus.initSelectizeInputs();
		membercontactus.validateForm();
		membercontactus.initContactForm();
		membercontactus.getCardStatusForPlatinum();
		membercontactus.makeAppointment();
		adobeDataLayer.push('pageLoaded', {
			'pageName': '',
			'pageType': 'Enrich Fly Contact Us',
			'attributes': []
		});
	} catch (e) { console.error(e); }
}
